<template>
    <div class="min-h-screen flex items-center justify-center bg-gray-100">
        <div class="p-6 max-w-sm w-full bg-white shadow-lg rounded-lg">
            <h2 class="text-2xl font-bold mb-6 text-center">Login</h2>

            <div class="flex flex-col gap-4">
                <label class="ui-input ui-input-bordered flex items-center gap-2">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 16 16"
                        fill="currentColor"
                        class="h-4 w-4 opacity-70"
                    >
                        <path d="M2.5 3A1.5 1.5 0 0 0 1 4.5v.793c.026.009.051.02.076.032L7.674 8.51c.206.1.446.1.652 0l6.598-3.185A.755.755 0 0 1 15 5.293V4.5A1.5 1.5 0 0 0 13.5 3h-11Z" />
                        <path d="M15 6.954 8.978 9.86a2.25 2.25 0 0 1-1.956 0L1 6.954V11.5A1.5 1.5 0 0 0 2.5 13h11a1.5 1.5 0 0 0 1.5-1.5V6.954Z" />
                    </svg>
                    <input
                        v-model="email"
                        type="text"
                        class="grow"
                        placeholder="Email"
                    />
                </label>

                <label class="ui-input ui-input-bordered flex items-center gap-2">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 16 16"
                        fill="currentColor"
                        class="h-4 w-4 opacity-70"
                    >
                        <path
                            fill-rule="evenodd"
                            d="M14 6a4 4 0 0 1-4.899 3.899l-1.955 1.955a.5.5 0 0 1-.353.146H5v1.5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-2.293a.5.5 0 0 1 .146-.353l3.955-3.955A4 4 0 1 1 14 6Zm-4-2a.75.75 0 0 0 0 1.5.5.5 0 0 1 .5.5.75.75 0 0 0 1.5 0 2 2 0 0 0-2-2Z"
                            clip-rule="evenodd"
                        />
                    </svg>
                    <input
                        v-model="password"
                        type="password"
                        class="grow"
                        value=""
                        placeholder="Password"
                    />
                </label>

                <!-- Forgot Password Link -->
                <a class="ui-link ui-link-neutral ml-auto">
                    <router-link to="/forgot-password">Forgot password?</router-link>
                </a>

                <div
                    v-if="error"
                    role="alert"
                    class="ui-alert ui-alert-error"
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="h-6 w-6 shrink-0 stroke-current"
                        fill="none"
                        viewBox="0 0 24 24"
                    >
                        <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"
                        />
                    </svg>
                    <span>{{ error }}</span>
                </div>

                <!-- Login Button -->
                <button
                    class="ui-btn bg-primary mt-4"
                    @click="signIn"
                >
                    Login
                </button>

                <!-- Sign Up link -->
                <a class="ui-link ui-link-neutral mx-auto">
                    <router-link to="/sign-up">Don't have an account? Register</router-link>
                </a>
            </div>
        </div>
    </div>
</template>

<script>
import { onAuthStateChanged, signInWithEmailAndPassword } from 'firebase/auth';
import { auth } from 'system/firebase.js';
import { useContextStore } from 'store/context.js';

export default {
    name: 'Login',
    data: () => ({
        email: '',
        password: '',
        loginDisabled: false,
        error: '',
    }),
    computed: {
        store() {
            return useContextStore();
        },
    },
    methods: {
        async signIn() {
            try {
                this.loginDisabled = true;

                onAuthStateChanged(auth, async (user) => {
                    if (user) {
                        const token = await user.getIdToken(false);

                        await this.store.authenticate(user, token);

                        this.$router.push('/');
                    }
                });

                signInWithEmailAndPassword(auth, this.email, this.password).catch((err) => {
                    this.loginDisabled = false;

                    if (err && err.code) {
                        console.log(err.code);
                        switch (err.code) {
                            case 'auth/user-not-found':
                                this.error = 'Oops, wrong email or password';
                                break;
                            case 'auth/wrong-password':
                                this.error = 'Oops, wrong email or password';
                                break;
                            case 'auth/invalid-email':
                                this.error = 'Oops, the provided email or password is wrong';
                                break;
                            case 'auth/user-disabled':
                                this.error = 'Oops, the user is disabled';
                                break;
                            default:
                                this.error = 'Oooops, cannot log in at this time';
                        }
                    }
                });
            } catch (err) {
                console.error(err);
                this.loginDisabled = false;
            }
        },
    },
};
</script>
